import { Component, OnInit,Input, Output, EventEmitter} from '@angular/core';
import{ LoopBackAuth, userService, correoService  } from '../../shared/services/api-rest.service';
import{MessageService} from '../../shared/services/message.service';
import { isNull } from 'util';
import { Usuarios } from '../modelos/usuarios';
@Component({
  selector: 'buscar-usuarios-grupo',
  template: `
  <div class="row">
    <div class="col-sm-9 mt-2">
        <div class="input-group input-group-sm mb-2">
          <span class="input-group-addon ">
            Buscar
          </span>
          <input
            type="text"
            class="form-control"
            placeholder="Filtrar"
            [(ngModel)]="search"
            >
        </div>
    </div>
    <div class="col-sm-2 mt-2 ">
        <button type="button" class="btn btn-primary pt-1 pb-1" (click)="agregar()"> 
          <i class="fa fa-spinner fa-spin" [hidden]="spinnerAgregar" ></i>+ Agregar
        </button>
    </div>
    <div class="col-sm-12 pr-0">
      <div class="table-responsive" [style.overflow-y]="'auto'" [style.height]="height">
        <table class="table buscar-usuarios">
          <thead>
            <tr>
              <th>
                <div class="p-0 border-checkbox-section">
                  <div class="border-checkbox-group">
                      <input
                          class="border-checkbox"
                          type="checkbox"
                          name="todos"
                          id="todos"
                          (change)="selectTodos($event.target.checked)"
                          >
                      <label 
                        class="border-checkbox-label" 
                        for="todos" 
                        [style.height]="'10px'"
                        [style.padding-left]="'10px'"
                        [style.margin-righ]="'0px'"></label>
                  </div>
                </div>
              </th>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Cedula</th>
              <th>Email</th>
          </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of listaUsuarios | filterBy:['apellido','nombre','identificacion','correo_electronico']: search">
              <td>
              <div class="p-0 border-checkbox-section">
                <div class="border-checkbox-group" [ngClass]="{'border-checkbox-group-default': !item.activo}">
                    <input
                        class="border-checkbox"
                        type="checkbox"
                        name="user_{{item.id}}"
                        id="user_{{item.id}}"
                        [disabled]="!item.activo"
                        [(ngModel)] = "item.select"
                        >
                    <label 
                      class="border-checkbox-label" 
                      for="user_{{item.id}}" 
                      [style.height]="'10px'"
                      [style.padding-left]="'10px'"
                      [style.margin-righ]="'0px'"></label>
                </div>
              </div>
              </td>
              <td> {{item.nombre}} </td>
              <td> {{item.apellido}} </td>
              <td> {{item.identificacion}}</td>
              <td> {{item.correo_electronico}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  `,
  providers:[LoopBackAuth, userService, correoService, MessageService]
})
export class BuscarUsuariosGrupoComponent implements OnInit {
  @Input() usuarios: any = []
  @Input() height:string
  @Input() idGrupo: number
  @Input() spinner: any
  @Output() emittAgregar= new EventEmitter()

  /** Variables  */
  listaUsuarios : any = []
  search: string
  spinnerAgregar:boolean = true

  constructor(
    private userService:userService,
    private correoService: correoService
  ) { }

  ngOnInit() {
    this.buscarUsuarios()
  }

  private buscarUsuarios(){
    this.spinner.isSpinnerVisible = true
    this.userService.search(true).subscribe(
      result=>{
        for(let item of result){
          item['select']= false
          item['activo']= true
        }
        this.listaUsuarios = result  
        this.bloquearUsuariosExistentes()
        this.spinner.isSpinnerVisible = false
      }
    )
  }

  public bloquearUsuariosExistentes(){
    this.limpiarSeleccionados()
    for(let usuario of this.listaUsuarios){
      for(let grupo of this.usuarios){
        if(usuario.id == grupo.glb_usuario_id) usuario.activo = false
      }
    }
  }

  public limpiarSeleccionados(){
    for(let usuario of this.listaUsuarios){
      usuario.activo = true
    }
  }

  public selectTodos(event : boolean){
    for(let item of this.listaUsuarios){
      item.select = event
    }
  }

  public agregar(){
    this.spinnerAgregar = false
    this.correoService.agregarUsuarioGrupo(this.idGrupo,this.buscarSeleccionados(this.listaUsuarios)).subscribe(
      result=>{
        if(!isNull(result)){
          this.emittAgregar.emit(result)
          for(let usuario of this.listaUsuarios){
            if(usuario.select) usuario.activo = false
          }
          this.spinnerAgregar = true
        }
      }
    )
  }

  private buscarSeleccionados(datos:any){
    let lista = []
    for(let item of this.listaUsuarios){
      if(item.select && item.activo) lista.push(item)
    }
    return lista
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/element/buscar-usuarios-grupo.component.ts